<template>
  <div>
    <div class="scroll" :loaded="loaded">
      <div style="padding-bottom:30px">
        <div v-show="loaded">
          <div class="daka-head">
            <img :src="info.banner" alt="">
            <div class="title">
              <div class="name">{{info.name}}  <span class="extra">{{info.honor}}</span> <!-- {{info.level_desc}} {{info.level}} --></div>
              <!-- <div class="extra">{{info.honor}}</div> -->
            </div>
            <!-- <div class="zan" :class="{deactive:!info.is_like}" @click="zan">
              <i class="iconfont icon-zan"></i>
              点赞
            </div> -->
            <div class="follow" :class="{deactive:info.is_follow}" @click="follow">
              <span v-if="!info.is_follow">+</span>{{info.is_follow ? '已关注' : '关注'}}
            </div>
          </div>
          <ul class="attr border-bottom">
            <li>
              <p>{{info.work_age}}年</p>
              <p>从业年限</p>
            </li>
            <li>
              <p>{{info.answers}}次</p>
              <p>回答次数</p>
            </li>
            <li>
              <p>{{info.star}}星评价</p>
              <p class="xing"><span class="iconfont icon-xingxing" v-for="(item, index) in info.star" :key="index"></span></p>
            </li>
          </ul>
          <div class="extra-attr border-bottom">
            <div>
              <i class="iconfont icon-gou1"></i>平均响应时间: {{info.nextInfo.response_time}}分钟
            </div>
            <div>
              <i class="iconfont icon-gou1"></i>{{info.nextInfo.company}}
            </div>
            <div>
              <i class="iconfont icon-gou1"></i>{{info.nextInfo.auth}}
            </div>
          </div>
          <div class="good-at border-bottom">
            <p class="title">擅长车型</p>
            <div>
              <label class="car-pro" v-for="(car, index) in info.advance_car" :key="index">{{car}}</label>
            </div>
          </div>
          <div class="intro border-bottom">
            <p class="title">个人简介</p>
            <p class="p intro-html" v-html="info.introduction"></p>
            <div class="more" v-if="false">
              查看全部
            </div>
          </div>
          <div class="course border-bottom">
            <p class="title">他的课堂</p>
            <div class="wrap">
              <router-link tag="div" v-if="info.isExistSingle" :to="{path:'/micro',query:{teacher:info.teacher_id}}">
                微课堂
              </router-link>
              <div v-else class="disabled" @click="nocourse('暂无微课')">
                微课堂
              </div>
              <router-link tag="div" v-if="info.isExistClass" :to="{path:'/systematic',query:{teacher:info.teacher_id}}">
                体系课
              </router-link>
              <div v-else class="disabled" @click="nocourse('暂无体系课')">
                体系课
              </div>
            </div>
          </div>
          <div class="same">
            <p class="title">相关大咖</p>
            <div class="item" v-for="other in info.relationTeachers" :key="other.id">
              <div class="img-wrap">
                <img v-lazy="other.icon" alt="">
              </div>
              <div class="wrap">
                <router-link :to="'/daka/'+other.id" tag="div">
                  <p class="name">{{other.name}}<label v-for="l in other.advantage" :key="l">{{l}}</label></p>
                </router-link>
                <p class="job">{{other.honor}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 加载动画 -->
    <loading v-show="!loaded"></loading>
    <qr-popup class="qr-popup" :show="showQrPopup" :img="qrurl" :text="qrtext"></qr-popup>
  </div>
</template>

<script>
import Loading from 'components/base/loading/loading.vue'
import Scroll from 'components/base/scroll/scroll'
import {getDkDetail} from '@/api/daka.js'
import {zanDaka, dakaShare, ChannelHaoYou, ChannelPengYouQuan, followDaka, unfollowDaka} from '@/api/user-behavior.js'
import {RES_OK} from '@/api/config'
import {wxShare} from '@/api/wx-share.js'
import QrPopup from 'components/base/qr-popup'
export default {
  components: {
    Loading,
    Scroll,
    QrPopup
  },
  data() {
    return {
      info: {
        nextInfo: {}
      },
      loaded: false,
      following: false, // 请求接口中,防止多次点击
      // 关注大咖操作二维码弹框
      showQrPopup: false,
      qrurl: '',
      qrtext: ''
    }
  },
  created() {
    // console.log(this.$route.params.id)
    this.loaddata()
  },
  watch: {
    $route: function(route) {
      this.loaddata()
    }
  },
  methods: {
    loaddata() {
      this.loaded = false
      getDkDetail(this.$route.params.id).then((res) => {
        let data = res.data
        if (data && data.code === RES_OK && data.data) {
          this.info = data.data
          this.loaded = true
          // 数据返回了, 设置分享
          wxShare({
            success: () => {
            // 分享到朋友
              dakaShare(this.info.user_id, ChannelHaoYou)
            }
          }, {success: () => {
            // 分享到朋友圈
            dakaShare(this.info.user_id, ChannelPengYouQuan)
          }})
        }
      })
    },
    zan() {
      // 废弃点赞了
      const zan = this.info.is_like
      zanDaka(this.info.teacher_id).then((res) => {
        let data = res.data
        if (data && data.code === RES_OK) {
          this.info.is_like = !zan
        }
      })
    },
    nocourse(msg) {
      this.$toast(msg)
    },
    follow() {
      if (!this.following) {
        this.following = true
        const cb = res => {
          const data = res.data
          if (data && data.code === RES_OK) {
            if (this.info.is_follow) {
              this.$toast('取消关注成功')
              this.showQrPopup = false
            } else {
              this.$toast('关注成功')
              if (data.data.qrurl) {
                console.log('弹出关注二维码')
                this.qrurl = data.data.qrurl
                this.qrtext = '关注公众号, 不会错过老师上新课程'
                this.showQrPopup = true
              }
            }
            this.info.is_follow = !this.info.is_follow
          } else if (data && data.msg) {
            // 打印错误信息
            console.log(data.msg)
          }
          this.following = false
        }
        if (this.info.is_follow) {
          // 已关注状态,就取消关注
          unfollowDaka(this.info.teacher_id).then(cb)
        } else {
          // 未关注,现在就关注
          followDaka(this.info.teacher_id).then(cb)
        }
      }
    }
  }
}
</script>
<style>
.intro-html img{
  width: 100%!important;
}
</style>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .scroll
  .border-bottom
    position relative
    &:before
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      height: 1px;
      content: '';
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
      background-color: #e6e6e6;
  .daka-head
    min-height size(100)
    position relative
    img
      width 100%
      height size(360)
      display block
    .title
      position absolute
      left 0
      bottom 0
      width 100%
      padding size(25) size(30)
      line-height 1
      background linear-gradient(to bottom,rgba(0,0,0,0) ,rgba(80,80,80,.8) );
    .name
      font-size size(30)
      font-weight 800
      color #fff
      .extra
        font-weight 500
        font-size size(24)
    // .extra
    //   font-size size(24)
    //   color #fff
    //   margin-top size(18)
    //   white-space nowrap
    //   overflow hidden
    //   text-overflow ellipsis
    .zan
      position absolute
      right 0
      top size(52)
      background #fff
      line-height size(52)
      border-top-left-radius size(26)
      border-bottom-left-radius size(26)
      min-width size(132)
      font-size size(24)
      color #ff8125
      text-indent size(28)
      .iconfont
        font-size 14px
      &.deactive
        color #666
    .follow
      position absolute
      right 0
      top size(52)
      background #fff
      line-height size(52)
      border-top-left-radius size(26)
      border-bottom-left-radius size(26)
      min-width size(132)
      font-size size(24)
      color $color-theme
      text-align center
      &.deactive
        color #999
      span
        font-size size(28)
  .attr
    text-align center
    padding size(38) size(0)
    &:after
      content ' '
      display table
      clear both
    >li
      float left
      width 33.3%
      >p:first-child
        font-size size(32)
        color #333
        font-weight 700
      >p:last-child
        font-size size(24)
        color #999
        margin-top size(14)
    .iconfont
      color $color-theme
    .xing
      margin-top size(10)!important
  .extra-attr
    height size(60)
    width 100%
    display table
    padding 0 size(30)
    font-size size(24)
    >div
      display table-cell
      vertical-align middle
      overflow hidden
      &:last-child
        text-align right
      .iconfont
        display inline-block
        margin-right size(4)
        position relative
        top size(2)
        color $color-theme
  .good-at
    padding size(40) size(30)
    .title
      font-size size(34)
      color #333
      font-weight 800
      padding-bottom size(18)
    .car-pro
      display inline-block
      text-align center
      color $color-theme
      font-size size(26)
      padding size(8) size(20)
      border-radius size((26+9*2) /2 )
      border: 1px solid $color-theme
      margin-top size(12)
      margin-right size(30)
  .intro
    padding 0 size(30) size(40)
    .title
      font-size size(34)
      color #333
      font-weight 800
      padding-top size(40)
      padding-bottom size(30)
    .p
      font-size size(30)
      color #666
      line-height size(42)
      margin-bottom size(12)
    .more
      text-align center
      font-size size(30)
      color $color-theme
      padding size(40) 0
  .course
    padding 0 size(30)
    padding-bottom size(40)
    .title
      font-size size(34)
      color #333
      font-weight 800
      padding size(40) 0
    .wrap
      height size(145)
      text-align center
      >div
        line-height size(145)
        width 47%
        font-size size(34)
        color #fff
        border-radius size(8)
        &.disabled
          opacity .6
        &:first-child
          float left
          background #616176
          background-image url("~common/image/weike-bg.png")
          background-size 100% 100%
        &:last-child
          float right
          background #d6845c
          background-image url("~common/image/tixike-bg.png")
          background-size 100% 100%
  .same
    padding 0 size(30)
    padding-bottom size(32)
    .title
      font-size size(34)
      color #333
      font-weight 800
      padding size(40) 0
    .item
      width 100%
      display table
      margin-bottom size(30)
      table-layout fixed
      >div
        display table-cell
        vertical-align middle
      .img-wrap
        width size(102)
        height size(102)
        img
          width 100%
          height 100%
          // border-radius 50%
      .wrap
        padding-left size(32)
      .name
        font-size size(32)
        font-weight 800
        color #333
        >label
          float right
          font-size size(24)
          padding size(4) size(12)
          border-radius size(24+4*2)
          border: 1px solid $color-theme
          color $color-theme
          margin-left size(8)
      .job
        font-size size(26)
        color #999
        margin-top size(18)
        white-space nowrap
        overflow hidden
        text-overflow ellipsis
</style>



// WEBPACK FOOTER //
// src/components/daka/dk-detail.vue